import React from "react"

import Header from "../../components/Header"
import NavigationButtons from "../../components/NavigationButtons"
import Input from "../../components/Input/Input"

import styles from "../../css/Page.module.css"

const ChangeDataPlan = props => {
  return (
    <div>
      <Header title="Önskas surfmängden förändras?" />
      <div className={styles.inputContainer}>
        <Input
          name="changeDataPlanChoice"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
        />
      </div>
      {/*<NavigationButtons
        inputState={props.inputState}
  />*/}
    </div>
  )
}
  
export default ChangeDataPlan